export const Globals = {
NightlyBuild: '2026-08-03 09:00:06',
  Id: null,
  UserName: '',
  UserType: '',
  LoginTime: null,
  FirstName: '',
  LastName: '',
};

export const restoreAuthFromStorage = async () => {
  const token = localStorage.getItem('accessToken');
  const storedUser = localStorage.getItem('userData');
  
  if (!token) {
    return false;
  }

  // If we have stored user data, restore it without API call
  if (storedUser) {
    try {
      const userData = JSON.parse(storedUser);

      Globals.Id = userData.Id;
      Globals.UserName = userData.UserName;
      Globals.UserType = userData.UserType;
      Globals.FirstName = userData.FirstName;
      Globals.LastName = userData.LastName;
      Globals.LoginTime = new Date();

      return true;
    } catch (error) {
      console.error('Failed to parse stored user data:', error);
      localStorage.removeItem('userData');
    }
  }

  // If no user data or parsing failed, clear the token
  localStorage.removeItem('accessToken');
  return false;
};
             
// Not a hook, so callable from anywhere (event handlers, the fetch
// interceptor) - previously called useNavigate() outside a component,
// which would throw, and never actually cleared the stored token, so a
// "logged out" browser would just log itself back in on next load.
export const LogOut = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userData');
  fetch(`${process.env.REACT_APP_BLADE_API_URL}/api/users/logout`, { method: 'POST', credentials: 'include' }).catch(() => {});
  window.location.href = '/login';
};
